// extracted by mini-css-extract-plugin
export default {"Outer":"ExpandControls_Outer__umVUr","ExpandControls":"ExpandControls_ExpandControls__pVVei"};